import { stringify } from 'qs';
import { IGetRealtorsRequest } from '../repositories/agent-catalog-search/v1/get-realtors';

import { ETabs } from '../types/redux/tabs';
import { CATALOGS_PATHS } from '../constants/paths';

export function getQueryString(tab: ETabs, page: number, filters: IGetRealtorsRequest) {
  const pathname = CATALOGS_PATHS[tab];
  const { protocol, host } = window.location;
  const domain = `${protocol}//${host}${pathname}`;
  const queryString = stringify({ ...filters, page });

  return `${domain}?${queryString}`;
}
